var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsidebarDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.0161V10.9966M4 1.01611H8C9.65685 1.01611 11 2.35926 11 4.01611V12.0161C11 13.673 9.65685 15.0161 8 15.0161H4C2.34315 15.0161 1 13.673 1 12.0161V4.01611C1 2.35926 2.34315 1.01611 4 1.01611Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsidebarDevices);
export default __webpack_public_path__ + "static/media/iconsidebar_devices.451028eac6208a6dcc7d8e6c5cb03482.svg";
export { ForwardRef as ReactComponent };